import { FC, PropsWithChildren, ReactNode } from 'react'
import { useBoolean } from 'ahooks'

import { Button, ButtonProps } from '@trustycars/genie-ui/components'

import ExtraIcon from '$icons/ExtraIcon'

import {
  container,
  header,
  description as descriptionStyle,
  title as titleStyle,
  footer,
  badge,
  skipBtn
} from './styles.css'
import { LoginAttentionTypes } from '$services/api/types'
import useMFAInfo from '$actions/useMFAInfo'
import useConfigurePasskey from '$views/MFASetting/ConfigurePasskey/useConfigurePasskey'
import MFABlock from '$blocks/MFABlock'

export type InfoProps = {
  required?: boolean
  title: string
  description?: ReactNode
  onSkip: VoidFunction
  continueBtnText?: ReactNode
  type: LoginAttentionTypes
}

export const Info: FC<PropsWithChildren<InfoProps>> = ({
  required,
  title,
  description,
  onSkip,
  continueBtnText = 'Continue',
  type,
  children
}) => {
  const [isContinue, { setTrue }] = useBoolean(false)

  const mfaInfo = useMFAInfo()

  const {
    setup: { onSetup, mfaBlock, isAnyLoading }
  } = useConfigurePasskey({
    mfaInfo,
    setupOptions: { onRegistered: onSkip },
    updateOptions: { onUpdated: onSkip },
    removeOptions: { onRemoved: onSkip }
  })

  const isPasskeyRegistration = type === 'remind_passkey_registration'

  const buttonProps: ButtonProps = {
    onClick: isPasskeyRegistration ? onSetup : setTrue,
    disabled: isPasskeyRegistration ? isAnyLoading : undefined
  }

  if (isContinue) return children

  return (
    <>
      <section className={container}>
        <header className={header}>
          <div>
            <figure className={badge}>
              <ExtraIcon name="alert-triangle" />
            </figure>
          </div>
        </header>

        <main>
          <h2 className={titleStyle}>{title}</h2>

          {description && <p className={descriptionStyle}>{description}</p>}
        </main>

        <footer className={footer}>
          <button onClick={onSkip} className={skipBtn} disabled={required}>
            Skip For Now
          </button>

          <Button {...buttonProps}>{continueBtnText}</Button>
        </footer>
      </section>

      <MFABlock {...mfaBlock} />
    </>
  )
}

export default Info
